var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},_vm._l((_vm.links),function(link,key){return _c('a',{key:key,staticClass:"nav__link",attrs:{"href":link.path,"target":_vm.isExternalLink(link) ? '_blank' : '_self'}},[_vm._v(" "+_vm._s(link.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }